<div class="search-bar-holder">
  <div class="search-field" *ngIf="allowSearch">
    <ng-content select="[scaffoldSearchAddition]"></ng-content>
    <div class="search-by-field" *ngIf="searchData?.length > 0 && !hideTermSelect">
      <nb-form-field >
        <div class="inline-label">
          <label class="TablesTable-Header">{{'search_by'| translation}}</label>
          <nb-select [(ngModel)]="key" [placeholder]="'search_by'| translation">
            <nb-option *ngFor="let option of searchData" [value]="option.data">{{option.translation_key||option.label| translation| transformText:'capitalize'}}</nb-option>
            <nb-option value="all">{{'all'| translation|transformText:'capitalize'}}</nb-option>
          </nb-select>
        </div>
      </nb-form-field>
      <ng-content select="[scaffoldSearchAddition2]"></ng-content>
    </div>
    <div class="term-field" [ngClass]="{'two-buttons':term}">
      <nb-form-field>
        <input (keyup.enter)="initSearch()"
               nbInput
               [placeholder]="'search'| translation"
               type="text"
               [(ngModel)]="term"
                />
        <button nbSuffix
                style="background: transparent;"
                nbButton
                *ngIf="term"
                ghost
                status="basic"
                (click)="initSearch(true)"
                type="button"
                [title]="'clear_search'| translation">
                 <i class="fa-thin fa-xmark"></i>
              </button>
        <button nbSuffix
                style="background: transparent;"
                nbButton
                ghost
                status="basic"
                (click)="initSearch()"
                type="button">
                <i class="fa-thin fa-magnifying-glass"></i>
              </button>
      </nb-form-field>
    </div>

  </div>
  <ng-content select="[scaffoldSearchAddition3]"></ng-content>
  <div *ngIf="!forceOnlyActive && displayActiveStateFilter" class="inline-label">
    <label class="TablesTable-Header">{{activePlaceholder}}</label>
      <nb-select (selectedChange)="initSearch()"
                 [(ngModel)]="activeStateFilter"
                 [placeholder]="'item_state'| translation">
        <nb-option class="ppo" [value]="itemActiveStateFilterEnum.active">{{'active'| translation}}</nb-option>
        <nb-option class="ppo" [value]="itemActiveStateFilterEnum.inactive">{{'inactive'| translation}}</nb-option>
        <nb-option class="ppo" [value]="itemActiveStateFilterEnum.both">{{'both'| translation}}</nb-option>
      </nb-select>
  </div>
  <ng-content select="[scaffoldSearchAddition4]"></ng-content>
</div>
